import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { ResponseMessage } from "../model/FormsEntity/response";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })


export class LeaseRestoration {

    private leaseRestorationUrl: string;
    private leaseRestorationUrlWF: string;
    private leaseResotreBhumiUrl: string;
    constructor(private http: HttpClient) {
        this.leaseRestorationUrl = environment.baseUrl + 'leaseRestoration/';
        this.leaseRestorationUrlWF = environment.wflowUrl + 'leaseRestortion/workflow/';
        this.leaseResotreBhumiUrl = environment.baseUrl + 'leaseRestortion/bhumi/';
    }
    public saveLeaseRestoreApplication(lease) {
        console.log(lease);     //getPayHeadMasterListLD
        return this.http.post<ResponseMessage>(this.leaseRestorationUrl + 'saveleaseRestorationDetails', lease);
    }
    public getSaveAsDraftLeaseForm(id) {
        return this.http.get<any>(this.leaseRestorationUrl + 'getleaseRestorationDetails/' + id);
    }
    public getleaseRestorationDetailsByAppNo(id) {
        return this.http.get<any>(this.leaseRestorationUrl + 'getleaseRestorationDetailsByAppNo/' + id);
    }
    public getleaseRestorationDetailsWFList(id, roleName) {
        const params = new HttpParams()
            .set('id', id)
            .set('roleName', roleName);
        return this.http.get<any>(this.leaseRestorationUrl + 'getleaseRestorationDetailsWFList', { params });
    }

    public generateImage(fileName) {
        const httpOptions = {
            'responseType': 'arraybuffer' as 'json'
            //'responseType'  : 'blob' as 'json'        //This also worked
        };
        return this.http.post<any>(this.leaseRestorationUrl + 'getDownloadedFile', fileName, httpOptions);
    }
    public getUsersForWF(model) {
        return this.http.post<any>(this.leaseRestorationUrl + 'getUsersForWF', model);
    }

    public getAccountUsersOfLand(model) {
        return this.http.post<any>(this.leaseRestorationUrl + 'getAccountUsersOfLand', model);
    }

    public getSurveyUsersOfLand(model) {
        return this.http.post<any>(this.leaseRestorationUrl + 'getSurveyUsersOfLand', model);
    }


    public approveReject(model){
        return this.http.post<ResponseMessage>(this.leaseRestorationUrl +'approveRejDep',model);
    }
    public getLeaseRestorationWorkFlowRemarkHistory(appNo) {

        return this.http.get<any>(this.leaseRestorationUrlWF + 'getWorkFlowHistory/' + appNo);
    }

    public getDefeciencyDocList() {

        return this.http.get<any>(this.leaseRestorationUrl + 'getDefeciencyDocList');
    }
    public submitDefeciency(model){
        return this.http.post<ResponseMessage>(this.leaseRestorationUrl +'submitDefeciency',model);
    }
    public getBhumiDetails(model) {
        return this.http.post<any>(this.leaseResotreBhumiUrl + 'getBhumiDetails/', model);
    }
    public saveSubmitBhumiDetailsByApp(model) {
        return this.http.post<ResponseMessage>(this.leaseResotreBhumiUrl + 'saveSubmitBhumiDetailsByApp/', model);
    }
    public getUpdatedBhumiDataAppByAppNo(appId) {
        return this.http.get<any>(this.leaseResotreBhumiUrl + 'getUpdatedBhumiDataAppByAppNo/' + appId);
    }
    public getAdForwardListResponse(designation,appNo)
    {
        return this.http.get<any>(this.leaseRestorationUrl + 'getAdForwardListResponse/'+designation +'/'+ appNo);
    }
    public updateBhumiDetailsByDA(model) {
        return this.http.post<ResponseMessage>(this.leaseResotreBhumiUrl + 'updateBhumiDetailsByDA/', model);
    }
  
    public updateRecordByAccounntsFirLevelOfficer(model) {
        return this.http.post<ResponseMessage>(this.leaseResotreBhumiUrl + 'updateRecordByAccounntsFirLevelOfficer/', model);
    }
    public updateBhumiApiPaymentDataByAccounts(model) {
        return this.http.post<ResponseMessage>(this.leaseResotreBhumiUrl + 'updateBhumiApiPaymentDataByAccounts/', model);
    }
    public saveleasesurveyform(model)
    {
        return this.http.post<ResponseMessage>(this.leaseRestorationUrl + 'submitSurveyDeptRemark/', model);
    }
    public getDownladedZip(id)
    {
        return this.http.get<any>(this.leaseRestorationUrl + 'getDownladedZip/'+id );
    }
    public getAccountUsersOfLandSecond(model) {
        return this.http.post<any>(this.leaseRestorationUrl + 'getAccountUsersOfLandSecond', model);
    }
    public updatePaymentDataByAccounts(model) {
        return this.http.post<any>(this.leaseResotreBhumiUrl + 'updatePaymentDataByAccounts', model);
    }

    public getLeaseRestorationMISRecords(payload: any) {
  return this.http.post<any[]>(this.leaseRestorationUrl + 'records', payload);
}

public fetchBranchwiseCount(payload: any){
    return this.http.post<any[]>(this.leaseRestorationUrl + 'branchrecords' ,payload)
}


public generatePdfForLeaseRestoration(payload: any) {
  const httpOptions = {
    responseType: 'arraybuffer' as 'json'
  };

  return this.http.post<any>(
    this.leaseRestorationUrl + 'generatePdfForLeaseRestoration',
    payload,
    httpOptions
  );
}



uploadAdDocument(formData: FormData): Observable<any> {
  return this.http.post(this.leaseRestorationUrl + 'uploadAdDocument', formData, {
    responseType: 'text' 
  });

}

viewAdUploadedDocument(applicationNo: string): Observable<Blob> {
  const url = `${this.leaseRestorationUrl}viewAdUploadedDocument/${applicationNo}`;
  return this.http.get(url, { responseType: 'blob' });
}

}